import { Navigate, useLocation, useParams } from 'react-router-dom';
import { publicPath } from '../../utils/canonicalUrl';

/** Legacy: /argomenti[/slug] -> /blog[/slug]/ */
const RedirectArgomentiToBlog = () => {
  const { slug } = useParams();
  const { search, hash } = useLocation();
  const target = slug ? publicPath(`/blog/${slug}`) : publicPath('/blog');
  return <Navigate to={`${target}${search}${hash}`} replace />;
};

export default RedirectArgomentiToBlog;
